import {
  Button,
  LabeledDatePickerInput,
  LabeledSelect,
} from "@apex/component-library";
import { Wrap, WrapItem } from "@chakra-ui/react";
import { useFormikContext } from "formik";

import { getDatePickerFormattedDate } from "../../../utils/dateFormatter";
import InputFieldWrapper from "../../InputFieldWrapper";
import { RequirementsAndActivityFormValues, RequirementTypes } from "./types";

interface RequirementsAndActivityFormProps {
  isFetching: boolean;
}

const RequirementsAndActivityForm = ({
  isFetching,
}: RequirementsAndActivityFormProps) => {
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldValue,
    isValid,
    handleSubmit,
  } = useFormikContext<RequirementsAndActivityFormValues>();

  const handleSetDate = (fieldName: string, date: string | Date) => {
    setFieldValue(fieldName, getDatePickerFormattedDate(date));
  };

  return (
    <form onSubmit={handleSubmit}>
      <Wrap>
        <WrapItem>
          <InputFieldWrapper>
            <LabeledSelect
              label="Type"
              name="requirementType"
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.requirementType && !!errors.requirementType}
              errorMessage={errors.requirementType}
              data-testid="requirement-type-select"
            >
              <option value={RequirementTypes.Null}>{""}</option>
              <option value={RequirementTypes.Cash}>Cash</option>
              <option value={RequirementTypes.RegT}>RegT</option>
              <option value={RequirementTypes.DayTrades}>Day Trades</option>
            </LabeledSelect>
          </InputFieldWrapper>
        </WrapItem>
        <WrapItem>
          <InputFieldWrapper>
            <LabeledDatePickerInput
              label="From (Process Date)"
              onChange={(date: string | Date) => {
                handleSetDate("fromProcessDate", date);
              }}
              name="fromProcessDate"
              onBlur={handleBlur}
              date={values.fromProcessDate}
              placement="bottom"
              isRequired
              errorMessage={errors.fromProcessDate}
              isInvalid={touched.fromProcessDate && !!errors.fromProcessDate}
              data-testid="from-process-date-input"
            />
          </InputFieldWrapper>
        </WrapItem>
        <WrapItem>
          <InputFieldWrapper>
            <LabeledDatePickerInput
              label="To (Process Date)"
              onChange={(date: string | Date) => {
                handleSetDate("toProcessDate", date);
              }}
              name="toProcessDate"
              onBlur={handleBlur}
              date={values.toProcessDate}
              placement="bottom"
              isRequired
              errorMessage={errors.toProcessDate}
              isInvalid={touched.toProcessDate && !!errors.toProcessDate}
              data-testid="to-process-date-input"
            />
          </InputFieldWrapper>
        </WrapItem>
        <WrapItem alignItems="center" paddingTop="1rem">
          <Button
            variant="primary"
            isDisabled={!isValid || isFetching}
            type="submit"
            data-testid="search-button"
            isLoading={isFetching}
          >
            Search
          </Button>
        </WrapItem>
      </Wrap>
    </form>
  );
};

export default RequirementsAndActivityForm;
